import isString from 'lodash/isString';
import { useDropzone } from 'react-dropzone';
// @mui
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// type
//
import Image from '../Image';
import Iconify from '../Iconify';
import { UploadProps } from './type';
import RejectionFiles from './RejectionFiles';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  maxWidth: 200,
  maxHeight: 200,
  minHeight: 120,
  minWidth: 120,
  margin: 'auto',
  borderRadius: '50%',
  border: `2px dashed ${theme.palette.grey[500_32]}`,
}));

const DropZoneStyle = styled('div')({
  width: '100%',
  height: '100%',
  outline: 'none',
  display: 'flex',
  overflow: 'hidden',
  borderRadius: '50%',
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  '& > *': { width: '100%', height: '100%' },
});

const PlaceholderStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.neutral,
  transition: theme.transitions.create('opacity', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': { opacity: 0.8, cursor: 'pointer' },
}));

// ----------------------------------------------------------------------

export default function UploadAvatar({ error, file, helperText, sx, ...other }: UploadProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple: false,
    ...other,
  });

  return (
    <>
      <RootStyle
        sx={{
          ...((isDragReject || error) && {
            borderColor: 'error.light',
          }),
          ...sx,
        }}
      >
        <DropZoneStyle {...getRootProps()}>
          <input {...getInputProps()} />
          {file && <Image alt="avatar" src={isString(file) ? file : file.preview} />}
          <PlaceholderStyle
            className="placeholder"
            sx={{
              ...(file && {
                opacity: 0.6,
                color: 'common.white',
                bgcolor: 'grey.900',
              }),
              ...(isDragActive && { opacity: 0.8 }),
              ...((isDragReject || error) && {
                bgcolor: 'error.lighter',
              }),
            }}
          >
            <Iconify icon={'ic:round-add-a-photo'} sx={{ width: 24, height: 24, mb: 1 }} />
            <Typography variant="caption" sx={{ fontSize: '0.1rem' }}>
              {file ? 'アイコン画像を更新' : 'アイコン画像を設定'}
            </Typography>
          </PlaceholderStyle>
        </DropZoneStyle>
      </RootStyle>
      {helperText && helperText}
      {fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />}
    </>
  );
}
